import { useParams } from "react-router-dom";
import Breadcrumbs from "../../../components/breadcrumbs";
import { useEffect, useState } from "react";
import NotFound from "../../../components/not-found";
import { ExerciseViewModel } from "../../../viewModels";
import ExerciseService from "../../../services/ExerciseService";
import ExerciseEditForm from "./ui/ExerciseEditForm";
import ExerciseSkeleton from "./skeletons/ExerciseSkeleton";
import ExerciseCategoryService from "../../../services/ExerciseCategoryService";
import ExerciseLoadTypeService from "../../../services/ExerciseLoadTypeService";
import { AppFile, ExerciseCategory, ExerciseLoadType } from "../../../models";
import ExerciseFilesForm from "./ui/ExerciseFilesForm";
import AppFileService from "../../../services/AppFileService";
import ExerciseEditSkeleton from "./skeletons/ExerciseEditSkeleton";

export default function ExerciseEditPage() {
  const { id } = useParams<{ id: string }>();
  const [item, setItem] = useState<ExerciseViewModel | null>(null);
  const [loading, setLoading] = useState(true);
  const api = new ExerciseService();
  const apiFiles = new AppFileService();
  const apiCategories = new ExerciseCategoryService();
  const apiLoadTypes = new ExerciseLoadTypeService();
  const [categories, setCategories] = useState<ExerciseCategory[]>([]);
  const [loadTypes, setLoadTypes] = useState<ExerciseLoadType[]>([]);
  const [files,setFiles] = useState<AppFile[]>([]);

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    if (id) {
      const [categoriesData, loadTypesData, files] = await Promise.all([
        apiCategories.getExerciseCategories(),
        apiLoadTypes.getExerciseLoadTypes(),
         
        apiFiles.getAppFiles()
      ]);
      setCategories(categoriesData);
      setLoadTypes(loadTypesData);   
      setFiles(files);
      fetchExercise();
    }
  };
  const fetchExercise = async () => {
    if (id) {
      const data = await api.getExercise(id);
      setItem(data);
      setLoading(false);
    }
  }

  if (!loading && !item)
    return <NotFound message="Exercise not found."></NotFound>;

  return (
    <main className="max-w-3xl">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Exercises", href: "/admin/exercises" },
          { label: "Edit", href: `/admin/exercises/edit/${id}`, active: true },
        ]}
      />
      {loading ? <ExerciseEditSkeleton /> : null}

      {!loading && item ? <div>
        <ExerciseEditForm exercise={item} categories={categories} loadTypes={loadTypes} />
        <ExerciseFilesForm exercise={item} files={files} onReload={fetchExercise} ></ExerciseFilesForm>
      </div> 
      : null}
      
    </main>
  );
}
